import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const customUrlFn = (id, admin) => `${admin ? '/admin' : ''}/users${id ? '/'+id : ''}`

const state = {
  meta: {},
  isIviting: false
}

const actions = {
  invite({ commit }, { id, config, customUrlFnArgs = [] }) {
    const url = customUrlFn(id, customUrlFnArgs) + '/invite';
    commit('inviteStart')
    
    return api.client.post(url, config)
      .then(res => {
        commit('inviteEnd')
        return Promise.resolve(res.data);
      })
      .catch(err => {
        commit('inviteEnd')
        return Promise.reject(err.response.data);
      })
  }
}

const mutations = {
  inviteStart(state) {
    state.isIviting = true;
  },

  inviteEnd(state) {
    state.isIviting = false;
  }
}

export default createCrudModule({
  client: api.client,
  resource: 'users',
  parseList: res => res.data,
  parseSingle: res => res.data,
  onFetchListSuccess: (state, { meta }) => {
    if (meta) state.meta = meta;
  },
  customUrlFn,
  state,
  actions,
  mutations
});